<template>
  <router-view/>
</template>

<script>
export default {
  name: 'pageNo',
}
</script>
